"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const react_1 = require("react");
const utils_1 = require("./utils");
const utils_2 = require("../client/utils");
const useFragmentTypePolicyFieldName_1 = require("./useFragmentTypePolicyFieldName");
const useGetQueryDataByFieldName_1 = require("./useGetQueryDataByFieldName");
// A hook for subscribing to a fragment in the Apollo cache from a React component.
function useFragment(fragment, options) {
    const context = (0, react_1.useContext)((0, client_1.getApolloContext)());
    const client = context.client;
    const cache = client === null || client === void 0 ? void 0 : client.cache;
    const fieldName = (0, useFragmentTypePolicyFieldName_1.useFragmentTypePolicyFieldName)();
    const queryForFragment = (0, utils_1.useOnce)(() => (0, utils_2.buildWatchFragmentQuery)({
        fragment,
        fieldName,
        id: options.id,
        policies: cache.policies,
    }));
    return (0, useGetQueryDataByFieldName_1.useGetQueryDataByFieldName)(queryForFragment, fieldName, options);
}
exports.default = useFragment;
//# sourceMappingURL=useFragment.js.map